package com.yogaaicoach.pages.auth

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.booleanOrNull
import kotlinx.serialization.json.intOrNull
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

object TokenDataManager {
    private var _tokenData: TokenData? = null

    val tokenData: TokenData?
        get() = _tokenData

    fun initialize(accessToken: String, refreshToken: String, idToken: String, expirationTimestampMs: Long): TokenData {
        val claims = decodeJwtClaims(accessToken)
        val isSubscribed = claims["isSubscribed"]?.jsonPrimitive?.booleanOrNull
        val freeTrialDaysLeft = claims["freeTrialDaysLeft"]?.jsonPrimitive?.intOrNull

        _tokenData = TokenData.create(accessToken, refreshToken, idToken, expirationTimestampMs, isSubscribed, freeTrialDaysLeft)
        return _tokenData!!
    }

    fun clear() {
        _tokenData = null
    }

    @OptIn(ExperimentalEncodingApi::class)
    private fun decodeJwtClaims(token: String): JsonObject {
        val parts = token.split(".")
        if (parts.size != 3) throw IllegalArgumentException("Invalid JWT")

        val payload = parts[1]
            .replace('-', '+')
            .replace('_', '/')
            .let {
                // Pad Base64 string to multiple of 4
                it.padEnd((it.length + 3) / 4 * 4, '=')
            }

        val jsonString = Base64.decode(payload).decodeToString()
        return Json.parseToJsonElement(jsonString).jsonObject
    }
}